<template>
  <section>
    <b-container class="container-small">
      <b-card>
        <b-form-group
          class="mb-2"
          :label="$tk('ClientPortal.Sidebar.Create.ChooseAnExistingCampaign')"
          label-for="input-choose-existing"
        >
          <multiselect
            :options="options"
            :close-on-select="true"
            label="name"
            track-by="name"
            :option-height="48"
            :show-labels="false"
            @select="(selectedOption, id) => selectedValue(selectedOption)"
          >
            <template slot="placeholder">
              <span class="multiselect__placeholder mb-0">{{ $tk('ClientPortal.Form.SelectCampaign') }}</span>
            </template>
            <template
              slot="option"
              slot-scope="props"
            >
              <div class="option__desc">
                <span class="option__title">
                  <GjIcon
                    class="mr-50"
                    name="Folder"
                  />
                  {{ props.option.name }}
                </span>
              </div>
            </template>
            <template
              slot="caret"
              slot-scope="{ toggle }"
            >
              <div
                class="multiselect__select"
                @mousedown.prevent.stop="toggle()"
              >
                <GjIcon
                  class="icon-wrapper"
                  name="ArrowDown_fill"
                  size="21"
                />
              </div>
            </template>
          </multiselect>
        </b-form-group>
        <text-divider :text="$tk('ClientPortal.Sidebar.Create.Or')" />
        <div class="text-center mt-2">
          <b-button
            variant="outline-primary"
            size="sm"
            :to="'/' + this.$route.params.accountId + '/campaign/create'"
          >
            <GjIcon
              name="Plus"
              class="mr-50"
            />
            {{ $tk('ClientPortal.Sidebar.Create.CreateANewCampaign') }}
          </b-button>
        </div>
      </b-card>
    </b-container>
  </section>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import Multiselect from 'vue-multiselect'
import TextDivider from '@/components/TextDivider.vue'
import AdGroupService from '@/api/client/adgroups.service'
import {
  ref, watch, computed, onMounted,
} from '@vue/composition-api'
import notification from '@/mixins/toastification'

export default {
  components: {
    GjIcon,
    Multiselect,
    TextDivider,
  },
  mixins: [notification],
  props: {
    campaignId: Number,
    adGroupId: Number,
  },
  setup(props, context) {
    const options = ref([])
    const accountId = computed(() => context.root.$route.params.accountId)
    const getAdGroups = async () => {
      const campaignId = props.campaignId !== undefined ? props.campaignId : 0
      const adGroupId = props.adGroupId !== undefined ? props.adGroupId : 0
      try {
        const response = await AdGroupService.get(adGroupId, campaignId, accountId.value)
        options.value = response.campaigns
      } catch (error) {
        notification.methods.error(error.message)
      }
    }
    onMounted(() => {
      getAdGroups()
    })
    watch(accountId, () => {
      getAdGroups()
    })
    const selectedValue = selectedOption => {
      context.root.$router.push(`/${accountId.value}/adgroup/create?campaignId=${selectedOption.id}`)
    }
    return {
      options,
      selectedValue,
    }
  },
}
</script>
<style lang="scss" >
@import '@/assets/scss/libs/_vue-multiselect.scss';
</style>
